// src/components/ui/forms/FormInput/FormInputShadcn.jsx
import React from 'react';

// shadcn components
import { Input } from '../../input';

import { cn } from '../../../../utils/cn';

const FormInputShadcn = ({
  type = 'text',
  name,
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  variant = 'default', // 'default', 'emerald', 'blue'
  className = '',
  ...props
}) => {
  // Color variants extracted from old EventCreationPanel
  const variants = {
    default: {
      focus: "focus:border-slate-500/50 focus:ring-slate-500/20"
    },
    emerald: {
      focus: "focus:border-emerald-500/50 focus:ring-emerald-500/20"
    },
    blue: {
      focus: "focus:border-blue-500/50 focus:ring-blue-500/20"
    }
  };

  const variantStyles = variants[variant];

  return (
    <Input
      type={type}
      name={name}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      className={cn(
        // Additional custom styling
        "px-4 py-3 rounded-xl transition-all duration-200",
        "bg-slate-700/50 border-slate-600/50",
        "hover:border-slate-500/50",

        // Variant-specific colors
        variantStyles.focus,

        // Date input specific styles
        type === 'date' && [
          "cursor-pointer",
          "[&::-webkit-calendar-picker-indicator]:filter [&::-webkit-calendar-picker-indicator]:invert",
          "[&::-webkit-calendar-picker-indicator]:opacity-70 [&::-webkit-calendar-picker-indicator]:hover:opacity-100"
        ],

        className
      )}
      {...props}
    />
  );
};

export default FormInputShadcn;